import { Route } from 'react-router';
import AuthPromosPage from '../pages/AuthPromosPage/AuthPromosPage';
import AuthPromoDetailsPage from '../pages/AuthPromoDetailsPage/AuthPromoDetailsPage';
import ProtectedRoutes from '../components/ProtectedRoutes';

export const renderAuthPromosRoutes = () => (
  <Route path="auth-promos" element={<ProtectedRoutes />}>
    <Route index element={<AuthPromosPage />} />
    <Route path=":id" element={<AuthPromoDetailsPage />} />
  </Route>
);
